"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const framer_motion_1 = require("framer-motion");
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const components_1 = require("@/components");
const constants_1 = __importDefault(require("@/constants"));
const redux_1 = require("@/redux");
const selectors_1 = __importDefault(require("@/selectors"));
const bottom_sheet_1 = __importDefault(require("./bottom-sheet"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const support_menu_1 = __importDefault(require("./support-menu"));
const support_message_1 = __importDefault(require("./support-message"));
const types_1 = require("./types");
const SupportScreen = ({ messageSent, resetSupportMessage, }) => {
    const [messageType, setMessageType] = react_1.useState(null);
    return (react_1.default.createElement("div", { className: styles_scss_1.default.container },
        react_1.default.createElement(components_1.Meta, { title: constants_1.default.support.helmetTitle }),
        react_1.default.createElement("div", { className: styles_scss_1.default.contentContainer },
            react_1.default.createElement(components_1.Paper, { className: styles_scss_1.default.contentPaper },
                react_1.default.createElement("div", { className: styles_scss_1.default.contentPaperTopSection },
                    react_1.default.createElement("h3", null, constants_1.default.support.support)),
                react_1.default.createElement(support_menu_1.default, { type: types_1.SupportType.technical, messageType: messageType, setMessageType: setMessageType, resetSupportMessage: resetSupportMessage }),
                react_1.default.createElement(support_menu_1.default, { type: types_1.SupportType.clinical, messageType: messageType, setMessageType: setMessageType, resetSupportMessage: resetSupportMessage })),
            react_1.default.createElement(framer_motion_1.AnimatePresence, null, messageType ? (react_1.default.createElement(support_message_1.default, { resetSupportMessage: resetSupportMessage, setMessageType: setMessageType, messageType: messageType, messageSent: messageSent })) : null)),
        react_1.default.createElement(framer_motion_1.AnimatePresence, null, messageType ? (react_1.default.createElement(bottom_sheet_1.default, { className: styles_scss_1.default.bottomSheet, messageSent: messageSent, type: messageType, onClose: () => {
                resetSupportMessage();
                setMessageType(null);
            } })) : null)));
};
const mapDispatchToProps = (dispatch) => ({
    resetSupportMessage: () => dispatch(redux_1.ActionCreators.user.resetSupportMessage.dispatch()),
});
const mapStateToProps = (state) => ({
    messageSent: selectors_1.default.user.getSupportMessageSent(state),
});
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(SupportScreen);
